define([
	"csi/def/ActionFactory",
	"./_CustomViewAction"
], function(ActionFactory,_CustomViewAction) {

	return ActionFactory.declare("CustomViewSave", _CustomViewAction, {
		classController: "csi/view/customview/SaveController",

		customViewAccess: true,
		customViewDirty: true,
		customViewInstance: true
	});
});